import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useState } from 'react';
import { conversationsApi } from 'apis/conversations';
import { analytics } from 'app/utils/segment';
import { TagChips } from 'components/tags/tagChips';
import { TagsDropdownButton } from './components/tagsDropdownButton/tagsDropdownButton';
import styles from './conversationTags.module.scss';
/** Represents a component that presents the conversation tags. */
export const ConversationTags = ({ csid, }) => {
    const [tags, setTags] = useState([]);
    const { data, isFetching } = conversationsApi.useReadConversationQuery({
        csid,
    }, { refetchOnMountOrArgChange: true });
    const [updateConversationTag] = conversationsApi.useUpdateConversationTagMutation();
    useEffect(() => {
        if (data) {
            setTags(data.data.history.main_conversation.tags);
        }
    }, [data]);
    const handleChange = useCallback(({ selectedItem: { isSelected, value: tag }, }) => {
        if (isSelected) {
            updateConversationTag({ action: 'add', csid, tag });
            analytics.conversationHeaderTagAdded({ csid, tag: tag.name });
        }
        else {
            updateConversationTag({ action: 'remove', csid, tag });
            analytics.conversationHeaderTagRemoved({ csid, tag: tag.name });
        }
    }, [csid, updateConversationTag]);
    const handleRemove = useCallback((tag) => {
        updateConversationTag({ action: 'remove', csid, tag });
        analytics.conversationHeaderTagRemoved({ csid, tag: tag.name });
    }, [csid, updateConversationTag]);
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "100", className: styles.tags }, { children: [_jsx(TagsDropdownButton, { tags: tags, isLoading: isFetching, onChange: handleChange }), _jsx(TagChips, { tags: tags, limit: 3, onRemove: handleRemove, tagClassName: styles.tag })] })));
};
